// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2h1-K","actions":"GroupTable_actions__3swqX","deleteModalFooter":"GroupTable_deleteModalFooter__yLDKR"};